// A navigation that follows an already-confirmed leave (e.g. logout after the
// unsaved-changes prompt) must get past useNavigationGuard without re-prompting.
// Wrap such navigations in runWithNavBypass; the guard's interceptor lets
// navigations through while the flag is set.
const state = { active: false };

export const isNavBypassing = () => state.active;

export const runWithNavBypass = (fn) => {
    state.active = true;
    try {
        return fn();
    } finally {
        state.active = false;
    }
};
